import { OutlinedTextFieldProps, TextField } from '@mui/material';

export type DefaultTextFieldProps = Partial<OutlinedTextFieldProps>;

export const DefaultTextField = (props: DefaultTextFieldProps) => (
  <TextField variant="outlined" {...props} />
);
